module.exports = __webpack_public_path__ + "static/media/ic_co_browse_deactivate.1cac3cc1.svg";